module.exports = __webpack_public_path__ + "static/img/13.342ff8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/13.png
// module id = OUyn
// module chunks = 10